import { CSSProperties } from 'react';
import Scrollspy from 'react-scrollspy-ez';
import styled from 'styled-components';

import { textStyle } from '../../styles/mixins/_commonPageContentStyles';

interface Props {
  className?: string;
  title: string;
  ids?: string[];
  style?: CSSProperties;
}

const DEFAULT_STICKY_NAV_IDS: NonNullable<Props['ids']> = [
  'definition',
  'usage',
  'limitations',
  'colors',
  'related-plots',
];
const DEFAULT_STICKY_NAV_STYLE: NonNullable<Props['style']> = {};

const StickyNav = ({
  style = DEFAULT_STICKY_NAV_STYLE,
  className = '',
  title,
  ids = DEFAULT_STICKY_NAV_IDS,
}: Props) => (
  <div style={style} className={className}>
    <h2>{title}</h2>

    <Scrollspy
      ids={ids}
      offset={0}
      activeItemClassName="active"
      itemContainerClassName="multilevel-link-list"
    />
  </div>
);

const StyledStickyNav = styled(StickyNav)`
  position: sticky;
  margin-top: 40px;
  top: 40px;
  left: 100%;
  width: 10rem;

  > h2 {
    margin-bottom: 24px;
    color: ${({ theme }) => theme.neutralText};
    font-size: ${({ theme }) => theme.fontSizes.base};
    line-height: ${({ theme }) => theme.lineHeights.base};
  }

  ul {
    list-style: none;

    > li {
      position: relative;
      padding: 8px 8px 8px 24px;
      color: ${({ theme }) => theme.neutralTextWeak};
      ${textStyle('actions14Sb')}
      cursor: pointer;

      &:before {
        left: 0;
        content: '';
        position: absolute;
        top: 0;
        width: 2px;
        height: 100%;
        background-color: ${({ theme }) => theme.neutralBorder};
        transition:
          background-color 0.3s ease-in-out,
          border-color 0.3s ease-in-out;
      }

      &.active,
      &:hover {
        color: ${({ theme }) => theme.primaryText};
        &:before {
          background-color: ${({ theme }) => theme.primaryBorder};
        }
      }
    }
  }
`;

export default StyledStickyNav;
